import { render } from "./Upload_Documents.vue?vue&type=template&id=23a73d0f&scoped=true"
import script from "./Upload_Documents.vue?vue&type=script&lang=js"
export * from "./Upload_Documents.vue?vue&type=script&lang=js"

import "./Upload_Documents.vue?vue&type=style&index=0&id=23a73d0f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23a73d0f"]])

export default __exports__